// import * as admin from 'firebase-admin'
//
// const serviceAccount = require('../../learnobit-36a54-firebase-adminsdk-q5jnk-cb28f6d8e4.json')
//
// admin.initializeApp({
//   credential: admin.credential.cert(serviceAccount),
//   databaseURL: 'https://learnobit-36a54.firebaseio.com'
// })
//
// const firebase = admin.firestore()
import firebase from 'firebase/app'
import 'firebase/firestore'
import i18next from 'i18next'
import { showToastByMenuDirection } from '../helper/functions'

firebase.initializeApp({
  apiKey: 'AIzaSyCdAre04VVqWfEVKi10-Uqf7Im8y5d4Ra8',
  authDomain: 'learnobit-36a54.firebaseapp.com',
  databaseURL: 'https://learnobit-36a54.firebaseio.com',
  projectId: 'learnobit-36a54',
  storageBucket: 'learnobit-36a54.appspot.com',
  messagingSenderId: '529673593815',
  appId: '1:529673593815:web:2383bbfd452cd893f4e192'
})

// -----------------------------------------------------------------------------------------------------------
// firebase.database.INTERNAL.forceWebSockets()
// firebase.INTERNAL.forceWebSockets()

firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED
})

firebase.firestore().enablePersistence().then(() => {
  if (process.env.NODE_ENV !== 'production') {
    console.tron.log('enablePersistence set')
  }
}).catch((e) => {
  if (e.code === 'failed-precondition') {
    // throw new Error('multiple tabs opened')
    showToastByMenuDirection({
      message: i18next.t('LearnObit is being opened in several windows. it might work in a strange way.'),
      intent: 'warning'
    })
  }
  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'enablePersistence',
      value: {
        e
      },
      important: true
    })
  }
})

const Firestore = firebase.firestore()
// Firestore.collection('test').doc('test').set({ foo: 'bar' })
// -----------------------------------------------------------------------------------------------------------
// -----------------------------------------------------------------------------------------------------------
//
// const ui = new firebaseui.auth.AuthUI(firebase.auth())
// const uiConfig = {
//   callbacks: {
//     signInSuccessWithAuthResult: function(authResult, redirectUrl) {
//       // User successfully signed in.
//       // Return type determines whether we continue the redirect automatically
//       // or whether we leave that to developer to handle.
//       return true
//     },
//     uiShown: function () {
//       // The widget is rendered.
//       // Hide the loader.
//       document.getElementById('loader').style.display = 'none'
//     }
//   },
//   // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
//   signInFlow: 'popup',
//   signInOptions: [
//     {
//       provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
//       requireDisplayName: false
//     }
//   ]
//   // Other config options...
// }
//
// ui.start('#firebaseui-auth-container', uiConfig)

export default Firestore
